import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Invoice2 from "./Invoice2";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;

function POListMenu() {
  const currentDate = new Date().toLocaleDateString();
  const [poList, setPoList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [valuExport, setExport] = useState([]);

   const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(poList.length / itemsPerPage);
    const paginatedList = poList.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

  const fetchPOList = (date = "", status = "") => {
    console.log("Fetching PO list...");
    let url = "https://ims-backend.indevconsultancy.in/api/purchaselist/";
    const params = [];

    if (date) params.push(`date=${encodeURIComponent(date)}`);
    if (status) params.push(`status=${encodeURIComponent(status)}`);

    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    axios
      .get(url)
      .then((response) => {
        if (response) {
          setPoList(response.data?.data || []);
          console.log(response.data.data); // ✅ Log directly from response
        }
      })

      .catch((error) => {
        console.error("Failed to fetch PO list:", error);
      })
      .finally(() => {
        setLoading(false); // ✅ Important to stop loading spinner
      });
  };

  useEffect(() => {
    fetchPOList(); // ✅ Call the API on component mount
  }, []);

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <span className="fs-1">PO List</span>
          </div>
          <div className="col">
            <nav className="py-2" aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-end">
                <li className="breadcrumb-item active">PO List</li>
                <li className="breadcrumb-item">
                  <Link to="/mobilehome">Home</Link>
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="row g-3">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header border-info">
                <form>
                  <div className="row g-3">
                    <div className="col-lg">
                      <select className="form-select" id="datefilter">
                        <option value="">Select Status</option>
                        <option value="Recieved">Recieved</option>
                        <option value="Pending">Pending</option>
                      </select>
                    </div>

                    <div className="col-lg">
                      <RangePicker
                        style={{
                          width: "100%",
                          height: "35.50px",
                          borderRadius: "0.375rem",
                          border: "1px solid #ced4da",
                          padding: "0.375rem 0.75rem",
                        }}
                      />
                    </div>
                    {/* <div className="col-lg">
                      <input type="date" className="form-select" />
                    </div> */}
                    <div className="col-lg-2">
                      <button type="submit" className="btn btn-primary w-100">
                        Search
                      </button>
                    </div>
                    <div className="col-lg-1">
                      <a
                        href="list.html"
                        className="btn btn-outline-dark w-100"
                      >
                        Reset
                      </a>
                    </div>
                  </div>
                </form>
              </div>

              <div className="card-body">
                <div className="row g-0 align-items-center">
                  <div className="col-sm-7 mb-3">
                    <h6 className="fw-bold mb-0">
                      Total PO(s): <span>{poList.length}</span>
                    </h6>
                  </div>
                </div>

                <div className="table-responsive scrollbar">
                  {loading ? (
                    <p>Loading...</p>
                  ) : paginatedList.length === 0 ? (
                    <p>No Purchase Orders Found</p>
                  ) : (
                    <table className="table text-center table-bordered table-striped fs--1 mb-0">
                      <thead className="bg-primary text-white">
                        <tr>
                          <th>S.No.</th>
                          <th>Purchase ID</th>
                          <th>Vendor Name</th>
                          <th>Requisition ID</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        
                        {paginatedList.map((item, index) => (
                          <tr key={item.id}>
                            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                            <td>{item.purchaseid}</td>
                            <td>{item.vendor_name}</td>
                            <td>{item.requistionid || "-"}</td>
                            <td>{currentDate}</td>
                            <td>
                              <button className="bg-success rounded border-0 text-white">
                                {item.status === 1 ? "Received" : "Pending"}
                              </button>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                <i className="fas fa-eye"></i>
                              </button>
                              <button
                                className="btn ms-2 btn-sm btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#viweModal"
                                title="View"
                              >
                                Document View
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="viweModal"
        tabIndex="-1"
        aria-labelledby="registerModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <form>
              <div className="modal-header">
                <h5 className="modal-title" id="registerModalLabel">
                  View{" "}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body py-2">
                <Invoice2 data={valuExport}/>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default POListMenu;
